// extracted by mini-css-extract-plugin
export default {"Catalog__addedLabel":"Catalog_Catalog__addedLabel__18F9P","Catalog__preloader":"Catalog_Catalog__preloader__2g11k"};